import { ihiReviewLogClient } from '@/api/patients/ihiReviewLogClient';
import { QueryKey } from '@/data/query';
import type { FindIHIReviewLogsQueryApiDto } from '@montugroup/pms-api-contracts';

interface IhiPageParams {
  size: number;
  after?: string;
  before?: string;
}

export const useGetIhiReviewLog = (pageParams: IhiPageParams, filterParams: FindIHIReviewLogsQueryApiDto) => {
  const queryClient = ihiReviewLogClient();

  const {
    data: listAllData,
    isError: listAllIsError,
    isLoading: listAllIsLoading
  } = queryClient.listAll.useQuery({
    queryKey: [QueryKey.GetIhiReviewLogs, pageParams, filterParams],
    queryData: {
      query: { page: pageParams }
    }
  });

  return {
    data: listAllData,
    isError: listAllIsError,
    isLoading: listAllIsLoading
  };
};
